import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "toolbar",
    "selectedCount",
    "ruleIdsInput",
    "deleteRuleIdsInput",
    "priorityRuleIdsInput",
    "statusForm",
    "deleteForm",
    "priorityForm"
  ]
  static values = {
    statusRequiredMessage: String,
    deleteNoneMessage: String,
    deleteConfirmMessage: String,
    priorityRequiredMessage: String,
    priorityRangeMessage: String,
    priorityNoneMessage: String
  }

  connect() {
    this.selectedIds = new Set()
  }

  toggleAll(event) {
    const checkboxes = this.element.querySelectorAll('tbody input[type="checkbox"]')
    const isChecked = event.target.checked
    
    checkboxes.forEach(checkbox => {
      checkbox.checked = isChecked
      if (isChecked) {
        this.selectedIds.add(checkbox.value)
      } else {
        this.selectedIds.delete(checkbox.value)
      }
    })
    
    this.updateToolbar()
  }

  toggleItem(event) {
    const checkbox = event.target
    const id = checkbox.value
    
    if (checkbox.checked) {
      this.selectedIds.add(id)
    } else {
      this.selectedIds.delete(id)
      // 전체 선택 체크박스도 해제
      const selectAllCheckbox = this.element.querySelector('thead input[type="checkbox"]')
      if (selectAllCheckbox) {
        selectAllCheckbox.checked = false
      }
    }
    
    this.updateToolbar()
  }

  updateToolbar() {
    const count = this.selectedIds.size
    
    if (count > 0) {
      this.toolbarTarget.style.display = 'block'
      this.selectedCountTarget.textContent = count
      
      // 선택된 ID들을 hidden field에 설정
      const idsArray = Array.from(this.selectedIds)
      if (this.hasRuleIdsInputTarget) {
        this.ruleIdsInputTarget.value = idsArray.join(',')
      }
      if (this.hasDeleteRuleIdsInputTarget) {
        this.deleteRuleIdsInputTarget.value = idsArray.join(',')
      }
      if (this.hasPriorityRuleIdsInputTarget) {
        this.priorityRuleIdsInputTarget.value = idsArray.join(',')
      }
    } else {
      this.toolbarTarget.style.display = 'none'
    }
  }

  // 상태 변경 폼 제출 전 처리
  submitStatusForm(event) {
    const form = event.target
    const statusSelect = form.querySelector('select[name="status"]')
    
    if (!statusSelect.value) {
      event.preventDefault()
      alert(this.statusRequiredMessageValue || 'Status is required.')
      return false
    }
    
    return true
  }

  // 삭제 폼 제출 전 처리
  submitDeleteForm(event) {
    const selectedCount = this.selectedIds.size
    if (selectedCount === 0) {
      event.preventDefault()
      alert(this.deleteNoneMessageValue || 'Please select rules to delete.')
      return false
    }
    
    const messageTemplate = this.deleteConfirmMessageValue || 'Delete {count} selected rules?'
    const message = messageTemplate.replace('{count}', selectedCount)
    return confirm(message)
  }

  // 우선순위 변경 폼 제출 전 처리
  submitPriorityForm(event) {
    const form = event.target
    const input = form.querySelector('input[name="priority"]')
    if (!input || !input.value) {
      event.preventDefault()
      alert(this.priorityRequiredMessageValue || 'Enter priority (1-100).')
      return false
    }
    const prio = parseInt(input.value, 10)
    if (isNaN(prio) || prio < 1 || prio > 100) {
      event.preventDefault()
      alert(this.priorityRangeMessageValue || 'Priority must be 1-100.')
      return false
    }
    if (this.selectedIds.size === 0) {
      event.preventDefault()
      alert(this.priorityNoneMessageValue || 'Select rules to change priority.')
      return false
    }
    return true
  }
}
